import { render, staticRenderFns } from "./EditVideo.vue?vue&type=template&id=1965a6ba&scoped=true&"
import script from "./EditVideo.vue?vue&type=script&lang=js&"
export * from "./EditVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1965a6ba",
  null
  
)

export default component.exports